import { render, staticRenderFns } from "./law-cases-page.vue?vue&type=template&id=6436b452"
import script from "./law-cases-page.vue?vue&type=script&lang=js"
export * from "./law-cases-page.vue?vue&type=script&lang=js"
import style0 from "./law-cases-page.vue?vue&type=style&index=0&id=6436b452&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports